import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onRemoveSuggestionPill = action(
    'onRemoveSuggestionPill',
    (suggestionPillId: string, scenarioId: SearchScenarioId, actionSource: string) => ({
        suggestionPillId,
        scenarioId,
        actionSource,
    })
);

export default onRemoveSuggestionPill;
